import { FrameName } from "../config";
import type { TileEntityWithOnUpgradeMethod } from "../TileEntity";
import AbstractSalvageableTileEntity from "./AbstractSalvageableTileEntity";

class WolfsDenSalvageableTileEntity
	extends AbstractSalvageableTileEntity
	implements TileEntityWithOnUpgradeMethod
{
	public static readonly frameName = FrameName.WOLFS_DEN;
}

export default WolfsDenSalvageableTileEntity;
